const useBuildSearch = ()=>{
  return ()=>{
    return '/search/';
  };
};
export default useBuildSearch;
export { useBuildSearch };